export default {
  title: "サポート",
  payments: "お支払いに関するお問い合わせは {finance_email} までご連絡ください。",
  spam: "重要：「迷惑メール」フォルダもご確認ください。",
  other: "その他のお問い合わせは、下のフォームよりご連絡ください。",
  faq: "よくある質問",
  faq_notice:
    "リクエストを送信する前に、当社のルールと「{faq}（FAQ）」セクションをご確認ください — すでに回答がある場合があります。",
  response_time: "お問い合わせの複雑さとサポートの混雑状況により、回答に12時間〜2営業日かかる場合があります。"
};
